import React, { useMemo, useState } from 'react'

import { TableCustom } from "../../../../../components/common"
import PlanPagoDefinicionAnticipoCuotaModal from '../../../../../components/controls/PlanPagoDefinicionAnticipoCuotaModal'
import { buildCellAVMR } from "../../../utils"
import { useLista } from '../../../../../components/hooks/useLista';
import { ALERT_TYPE, OPERATION_MODE, ShowToastMessage } from '@laramie/ui';

const DefinicionAnticipo = ({ data, setData, params, setPendingChange, idTipoCobroAccesorios }) => {
    const [edittingAnticipo, setEdittingAnticipo] = useState()
    const [mode, setMode] = useState()

    const [, getRowLista] = useLista({
        listas: ['TipoCoberturaAnticipo'],
        onLoaded: (listas, isSuccess, error) => { if (!isSuccess) ShowToastMessage(ALERT_TYPE.ALERT_ERROR, error) },
        memo: { key: 'TipoCoberturaAnticipo', timeout: 0 }
    });

    const filteredData = useMemo(() => !data ? [] : data.filter(x => x.state !== 'r'), [data])

    const onAdd = () => {
        setEdittingAnticipo({
            id: -Date.now(),
            idPlanPagoDefinicion: parseInt(params.id),
            cuotaDesde: 0,
            cuotaHasta: 0,
            tieneAnticipo: false,
            idTipoCoberturaAnticipo: 0,
            porcentajeAnticipo: 0,
            state: 'a',
        })
        setMode('add')
    }

    const onView = (anticipo) => {
        setEdittingAnticipo(anticipo)
        setMode('view')
    }

    const onModify = (anticipo) => {
        setEdittingAnticipo(anticipo)
        setMode('modify')
    }

    const onRemove = (anticipo) => {
        setData(data.map(x => x.id === anticipo.id ? {...x, state: 'r'} : x))
        setPendingChange(true)
    }

    const onConfirm = (row) => {
        if (mode === 'add') {
            setData([...data, row])
        }

        else if (mode === 'modify') {
            setData(data.map(x => x.id === row.id ? {...row, state: row.state === 'a' ? 'a' : 'm',} : x))
        }

        setMode(null)

        setPendingChange(true)
    }

    const onDismiss = () => {
        setEdittingAnticipo(null)
        setMode(null)
    }

    return (
        <div className="col-12">

            <div className="col-12 p-top-15">
                <label className="form-label">Anticipo</label>
                <TableCustom
                    showFilterGlobal={false}
                    floatingDownloadCSVButton={true}
                    className='TableCustomBase'
                    columns={[
                        { Header: 'Cuota desde', accessor: 'cuotaDesde', width: '15%' },
                        { Header: 'Cuota hasta', accessor: 'cuotaHasta', width: '15%' },
                        { Header: 'Anticipo', accessor: 'tieneAnticipo', width: '12%', Cell: ({ value }) => value ? 'Sí' : 'No' },
                        { Header: 'Cobertura anticipo', accessor: 'idTipoCoberturaAnticipo', width: '33%', Cell: ({ value }) => getRowLista('TipoCoberturaAnticipo', value)?.nombre ?? '' },
                        { Header: 'Porcentaje', accessor: 'porcentajeAnticipo', width: '15%', Cell: ({ value }) => value > 0 ? value : '' },
                        buildCellAVMR({ onAdd, onView, onModify, onRemove, readOnly: params.mode === OPERATION_MODE.VIEW }),
                    ]}
                    data={filteredData}
                />
            </div>

            {!!mode && (
                <PlanPagoDefinicionAnticipoCuotaModal
                    data={{ entity: edittingAnticipo }}
                    disabled={mode === 'view'}
                    idTipoCobroAccesorios={idTipoCobroAccesorios}
                    onConfirm={onConfirm}
                    onDismiss={onDismiss}
                />
            )}
        </div>
    )
}

export default DefinicionAnticipo
